import { Box, Typography } from '@mui/material'
import React, { Fragment } from 'react'
import { UseFormReturn } from 'react-hook-form'
import EmailPreview from './email-preview'

interface ApplicationProps {
  formData: UseFormReturn<any>
}

const Application: React.FC<ApplicationProps> = ({ formData: { watch } }) => {
  return (
    <>
      <Typography variant='h6'>
        Visualize como sua marca aplicada nas nossas comunicações e sistema
      </Typography>

      <Box sx={{ width: '100%', height: '100vh' }}>
        <EmailPreview baseLogo={watch('baseLogo')} mainColor={watch('primaryColor')} />
      </Box>
    </>
  )
}

export default Application
